import Typography from '@mui/material/Typography';
import type { OptionsMap } from '@openx/types/options';
import { useCallback } from 'react';

import { AllowedItems } from './AllowedItems';
import { FiltersTitle } from './FiltersTitle';

interface SelectedFiltersProps {
  selectedOptions?: readonly string[];
  options?: OptionsMap;
  handleChange?: (values: string[]) => void;
  title: string;
  filtersTitle: string;
  readonly?: boolean;
  additionalFiltersInfo?: string;
}

export function SelectedFilters(props: SelectedFiltersProps) {
  const { selectedOptions, handleChange, options, title, readonly, filtersTitle, additionalFiltersInfo } = props;

  const onClear = useCallback(() => {
    if (!handleChange || readonly) return;
    handleChange([]);
  }, [handleChange, readonly]);
  const onRemove = useCallback(
    (filterId: string) => {
      if (!handleChange || readonly) return;
      handleChange((selectedOptions ?? []).filter(id => id !== filterId));
    },
    [handleChange, readonly, selectedOptions]
  );

  return (
    <>
      <FiltersTitle onClear={onClear} title={title} readonly={readonly} />
      <AllowedItems
        onRemove={onRemove}
        selectedOptions={[...(selectedOptions ?? [])]}
        options={options}
        title={filtersTitle}
        readonly={readonly}
        data-test={title}
      />
      {additionalFiltersInfo && (
        <Typography variant="body1" data-test={`${title.toLocaleLowerCase().split(' ')[0]}-additional`}>
          {additionalFiltersInfo}
        </Typography>
      )}
    </>
  );
}
